/* eslint-disable no-undef */
/**
 * Generating dynamic public path for webpack build configuration
 * This will allow that all JS files are availabe on other domain (example: CDN)
 */
const url = new URL(document.currentScript.src);
const publicPathLink = url.href.substring(0, url.href.lastIndexOf('/') + 1);
__webpack_public_path__ = publicPathLink;
